var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classnames from 'classnames';
// removed import of scss-style
export const GridWrapper = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("div", Object.assign({ className: classnames('GridWrapper', className) }, rest), children));
};
export const GridContainer = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("div", Object.assign({ className: classnames('GridContainer', className) }, rest), children));
};
export const GridCollapse = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("div", Object.assign({ className: classnames('GridCollapse', className) }, rest), children));
};
